// keep in sync with server/src/utils/domain.ts
/**
 * Normalizes a configured email domain: trims, lowercases and strips a leading "@".
 */
export const normalizeDomain = (domain: string | undefined | null) => {
    return (domain || '').trim().toLowerCase().replace(/^@/, '');
}

/**
 * Whether an email belongs to a domain or one of its subdomains.
 * Compares whole domain labels, so "acme.com" matches "a@acme.com" and "a@eng.acme.com"
 * but not "a@notacme.com".
 */
export const emailMatchesDomain = (email: string | undefined | null, domain: string | undefined | null) => {
    const required = normalizeDomain(domain);
    if (!required) {
        return true;
    }
    const at = (email || '').lastIndexOf('@');
    if (at < 0) {
        return false;
    }
    const actual = (email || '').slice(at + 1).trim().toLowerCase();
    return actual === required || actual.endsWith(`.${required}`);
}
